import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "system" | "light" | "dark";

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: "system",
      setMode: (mode) => {
        set({ mode });
        applyTheme(mode);
      },
    }),
    { name: "vg-theme" }
  )
);

export function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement;
  if (mode === "system") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", mode);
  }
}

/** Call once on app boot to apply the persisted theme immediately. */
export function initTheme(): void {
  const stored = (() => {
    try {
      const raw = localStorage.getItem("vg-theme");
      return raw ? (JSON.parse(raw) as { state?: { mode?: ThemeMode } }).state?.mode : undefined;
    } catch {
      return undefined;
    }
  })();
  applyTheme(stored ?? "system");
}
